import React from 'react';
import { Badge } from 'react-bootstrap';

import { Colors } from '_styles';

import { CreatedSla, DepartureSla } from './sla-cell';
import { formatShortDate } from './format';

// One passenger request, one value per column. Every passenger-supplied value is
// rendered as React text — no innerHTML and no links built from passenger data.
const RequestRow = ({ request, now, onView }) => {
  const flight = request.flight || {};
  const flightNumber = [flight.carrierCode, flight.flightNumber].filter(Boolean).join(' ');
  const std = formatShortDate(flight.departureDate);
  const assistance = Array.isArray(request.assistance) ? [...new Set(request.assistance)] : [];
  const note = typeof request.bio === 'string' ? request.bio.trim() : '';

  return (
    <tr onClick={() => onView(request)} style={styles.row}>
      <td style={styles.cell}>{request.name || '—'}</td>
      <td style={styles.assistance}>
        {assistance.length ? assistance.map((code) => (
          <Badge key={code} bg="primary" style={styles.code}>{code}</Badge>
        )) : '—'}
      </td>
      <td style={styles.cell}>{flightNumber || '—'}</td>
      <td style={styles.cell}>{request.origin?.iata || '—'}</td>
      <td style={styles.cell}>{request.destination?.iata || '—'}</td>
      <td style={styles.cell}>{request.pnr || '—'}</td>
      <td style={styles.cell}>{std || '—'}</td>
      <td style={styles.cell}>{formatShortDate(request.createdAt) || '—'}</td>
      <td style={styles.cell}>
        <CreatedSla createdAt={request.createdAt} now={now} />
      </td>
      <td style={styles.cell}>
        <DepartureSla flight={flight} now={now} />
      </td>
      <td style={styles.noteCell}>
        <span style={styles.note} title={note || undefined}>{note || '—'}</span>
      </td>
    </tr>
  );
};

const styles = {
  row: {
    cursor: 'pointer',
  },
  cell: {
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    fontSize: 14,
    color: Colors.PRM_GRAY,
    cursor: 'pointer',
  },
  assistance: {
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  code: {
    fontSize: 11,
    marginRight: 4,
  },
  noteCell: {
    verticalAlign: 'middle',
    minWidth: 320,
    maxWidth: 480,
    cursor: 'pointer',
  },
  note: {
    display: 'block',
    maxWidth: 480,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 14,
    color: Colors.PRM_GRAY,
  },
};

export default RequestRow;
